export const GET_STATES_LIST = 'providers/AddressProvider/GET_STATES_LIST';
export const GET_MUNICIPALITY_LIST = 'providers/AddressProvider/GET_MUNICIPALITY_LIST';
export const GET_NEIGHBORHOOD_LIST = 'providers/AddressProvider/GET_NEIGHBORHOOD_LIST';
export const GET_INFO_ZIP_CODE = 'providers/AddressProvider/GET_INFO_ZIP_CODE';
export const GET_INFO_ZIP_CODE_GEOCODING = 'providers/AddressProvider/GET_INFO_ZIP_CODE_GEOCODING';
